"use client"
import React, { useRef, useEffect,useState } from "react";
import '@/app/style/PDFViewer.scss';
import { PDF as PDFObject } from "./PDFCore";
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Slider from '@mui/material/Slider';
import CircularProgress from '@mui/material/CircularProgress'
import { styled } from '@mui/material/styles';
import HorizontalRuleOutlinedIcon from '@mui/icons-material/HorizontalRuleOutlined';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { textSize, text_size } from "@/app/utils/MixinSize";
import { useMyContext } from "@/app/utils/MyContext";

const PDFBtn=styled(Button)<{ $dimmed: boolean }>`
    background-color: #212121;
    border-radius: 0;
    height: 24px;
    min-width:24px;
    width:24px;
    box-shadow:none!important;
    :hover{
        background-color: #212121;
    }
    :focus{
        boxShadow: 0 0 0 0.2rem rgba(0,123,255,.5)
    }
    ${props => props.$dimmed && `
        opacity: 0.35 !important;
        pointer-events: none !important; /* 讓點擊事件完全穿透，等同於功能上的 disabled */
        cursor: not-allowed !important;
    `}
`

const PDFNavBtn=styled(Button)`
    width: 48px;
    height: 48px;
    padding: 0;
    display: contents;
`

const PDFInput=styled(TextField)`
    background-color: #212121;
    color: white;
    width: 60px;
    height: 24px;
    & input{
        padding:0px 0px;
        color:white;
        text-align:center;
        ${text_size(16)}
    }
    & input:focus{
        outline:unsert!important
    }
`

const PDFAvatar=styled(Avatar)`
    color:white;
    background-color:#212121;
    width: 100px;
    ${text_size(16)}
    height: 24px;
    justify-content: flex-start;
}
`

const PDFSlider=styled(Slider)`
    padding: 5px 0;
    border-radius: 8px;
    & .MuiSlider-track{
        background-color:white;
        border: 1px solid white;
    }
    & .airbnb-bar{
        background-color:white;
    }
    & .MuiSlider-rail{
        background-color:white;
    }
    & .MuiSlider-thumb{
        background-color:#fff;
        height: 10px;
        width: 10px;
        &:before{
            box-shadow:none!important;
        }
        &:hover{
            box-shadow:none!important;
        } 
        &:after{
            box-shadow:none!important;
            height:0px;
            width:0px;
        }
    }
    &:focus{
        box-shadow:none!important;
    }
    &:hover{
        box-shadow:none!important;
    } 
    &:before{
        box-shadow:none!important;
    }
    & .Mui-active{
        box-shadow:none!important;
    }
`

const ArrowBackIcon=styled(ArrowBackIosOutlinedIcon)`
    color: white;
    width: 32px;
    height: 32px;
`
const ArrowForwardIcon=styled(ArrowForwardIosOutlinedIcon)`
    color: white;
    width: 32px;
    height: 32px;
`
const LoadingProcess=(props:any)=>{
    return (
        <>
            {
                props.loading&&<div className="PDFLoading">
                    <CircularProgress disableShrink sx={(theme)=>({
                        animationDuration:'1.1s'
                    })}/>
                    {/* <span className="withText">{props.progress}%</span> */}
                </div>
            }
        </>
        
    )
}

export default function PDFViewer(props:any){
    const {state:myContextState} = useMyContext();
    const {url}=props
    const PDFContainerRef = useRef(null)
    const canvasContainerRef = useRef(null)
    const [zoom,setZoom]=useState('100%')
    const [currentZoom,setCurrentZoom]=useState('100%')
    const [pager,setPager]=useState('0/0')
    const [PDF,setPDF]=useState({} as PDFObject)
    const [maxStep,setStepMax]=useState(0)
    const [currentSlider,setCurrentSlider]=useState(1)
    const [sliderValue,setSliderValue]=useState(1)
    const [isFirstPage,setIsFirstPage]=useState(false)
    const [isLastPage,setIsLastPage]=useState(false)
    const [isPageReady,setIsPageReady]=useState(false) 
    const [isLoading,setIsLoading]=useState(true) 

    const handlePrevious=()=>{
        PDF.TriggerPrev((pageIndex:number,pageCount:number,spreadMode:number,isLastPage:boolean)=>{
            if(spreadMode==2){
                setPager(`${pageIndex}-${pageIndex+1} / ${pageCount}`)
                setIsLastPage(pageIndex + 1 == pageCount)     
            }
            else{
                setPager(`${pageIndex}/${pageCount}`)
                setIsLastPage(pageIndex==pageCount)     
            }   
            setIsFirstPage(pageIndex==1)
            setCurrentSlider(currentSlider-1)
            setSliderValue(currentSlider-1)   
        })
    }
    const handleNext=()=>{
        PDF.TriggerNext((pageIndex:number,pageCount:number,spreadMode:number,isLastPage:boolean)=>{
            if(spreadMode==2){
                if(pageIndex==pageCount){
                    setPager(`${pageIndex}/${pageCount}`)
                    setIsLastPage(pageIndex==pageCount) 
                }
                else{
                    setPager(`${pageIndex}-${pageIndex+1} / ${pageCount}`)
                    setIsLastPage(pageIndex + 1==pageCount) 
                }               
            }
            else{
                setPager(`${pageIndex}/${pageCount}`)
                setIsLastPage(pageIndex==pageCount) 
            }      
            setIsFirstPage(pageIndex==1)
            
            setCurrentSlider(currentSlider+1)
            setSliderValue(currentSlider+1)     
        })
    }

    const handleScale=(flag:string)=>{
        let _zoom=Math.floor(Number(zoom.replace('%',''))/10)*10
        if(flag=='+'){
            _zoom+=10
        }
        else if(flag=='-'){
            _zoom-=10
        }
        if(_zoom<100||_zoom>200){
            const _currentZoom = _zoom<100?`${100}%`:`${200}%`
            HandleSpecifyZoom(_currentZoom)
        }
        else{
            
            HandleSpecifyZoom(`${_zoom}%`)
        }
        
    }
    const HandleSpecifyZoom=(val:string)=>{
        const scale=val.replace(/%/g,'')
        const _scale=Number(scale)
        const _zoom=Number(currentZoom.replace('%',''))
        if(_scale!=_zoom){
            if(/^[0-9]{1,3}$/.test(scale)){
                PDF.TriggerScale(_scale,(__scale:number,__isSuccess:boolean)=>{
                    if(__isSuccess){
                        setCurrentZoom(`${scale}%`)
                    }                
                    setZoom(`${scale}%`)
                })
            }
        }        
        else{
            setZoom(currentZoom)
        }
    }
    const handleDownload=()=>{
        PDF.DownloadFile()
    }
    const handleSliderChange = (value: number) => {            
        if(value==currentSlider) return
        let curPage:number=PDF.spreadMode==2?value*2-1:value
        PDF.TriggerCurrenPage(curPage,(pageIndex:number,pageCount:number,spreadMode:number,isLastPage:boolean)=>{
            setIsFirstPage(pageIndex==1)
          

            if(spreadMode==2){
                if(pageIndex==pageCount){
                    setPager(`${pageIndex}/${pageCount}`)
                    setIsLastPage(pageIndex==pageCount) 
                }
                else{
                    setPager(`${pageIndex}-${pageIndex+1} / ${pageCount}`)
                    setIsLastPage(pageIndex + 1==pageCount) 
                }                 
            }
            else{
                setPager(`${pageIndex}/${pageCount}`)
                setIsLastPage(pageIndex==pageCount) 
            }            
        })
        setCurrentSlider(value)    
        setSliderValue(value)     
      };

    useEffect(()=>{  
        const pdf = new PDFObject(url)
        const PDFContainerElm:any=PDFContainerRef.current;
        pdf.initHeight=PDFContainerElm.clientHeight-98
        pdf.initWidth=PDFContainerElm.clientWidth-110
        pdf.spreadMode=props.PDFProps?.spreadMode||2
        pdf.Mount(myContextState.assetPrefix, canvasContainerRef,(pageIndex:number,pageCount:number,spreadMode:number)=>{            
            setIsFirstPage(pageIndex==1)
            setIsPageReady(true)
            if(spreadMode==2){
                if (pageCount == 1) {
                    setPager(`${pageIndex} / ${pageCount}`)
                    setIsLastPage(true)
                } else {
                    setPager(`${pageIndex}-${pageIndex+1} / ${pageCount}`)
                    setIsLastPage(pageIndex + 1==pageCount)
                }
                setStepMax(Number((pageCount/2).toFixed(0)))
            }
            else{
                setPager(`${pageIndex}/${pageCount}`)
                setStepMax(pageCount)          
                setIsLastPage(pageIndex==pageCount)  
            }              
          
            setIsLoading(false)
        })
        setPDF(pdf)
        return () => {
            pdf.UnMount()            
        }
    },[url])

    return( 
        <>        
            <div className="PDFContainer" ref={PDFContainerRef}>
                <LoadingProcess loading={isLoading}></LoadingProcess>               
                <div className="PDFViewer">
                    <div className="PDFNavBtnPrev">
                        {!isFirstPage&&isPageReady&&<div>
                            <PDFNavBtn onClick={()=>handlePrevious()}>
                                <ArrowBackIcon/>
                            </PDFNavBtn>
                        </div>}
                    </div>
                    <div className="PDFViewerContent">
                        <div className="PDFViewerScrollView" ref={canvasContainerRef}></div>
                    </div>                                
                    <div className="PDFNavBtnNext">
                        {!isLastPage&&isPageReady&&<div>
                            <PDFNavBtn onClick={()=>handleNext()}>
                                <ArrowForwardIcon/>
                            </PDFNavBtn>
                        </div>}
                    </div>
                </div>
                {isPageReady&&<div className="PDFViewerTools">
                    <div className="PDFViewerToolsSlider">
                        <PDFSlider
                            onChangeCommitted={(event: React.SyntheticEvent | Event, value: number | Array<number>)=>{handleSliderChange(value as number)}}
                            step={1}
                            min={1}
                            max={maxStep}
                            value={sliderValue}
                        />
                    </div>
                    <div className="PDFViewerToolsBtnContainer">
                        <div className="pager">
                            <PDFAvatar variant="square">{pager}</PDFAvatar>
                        </div> 
                        <div className="zoom">
                            <div>
                                <PDFBtn variant="contained" size="small" onClick={()=>handleScale('-')} $dimmed={Math.floor(Number(zoom.replace('%',''))/10)*10 <= 100} >
                                    <HorizontalRuleOutlinedIcon />
                                </PDFBtn>
                            </div>
                            <div>
                                <PDFInput size="small" value={zoom} className="PDFViewerTextField"
                                    onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                        HandleSpecifyZoom(event.target.value)
                                    }}
                                />
                            </div>
                            <div>
                                <PDFBtn variant="contained" size="small" onClick={()=>handleScale('+')}  $dimmed={Math.floor(Number(zoom.replace('%',''))/10)*10 >=200} >
                                    <AddOutlinedIcon />
                                </PDFBtn>                    
                            </div>
                        </div>                                   
                        <div className="tools">  
                            <PDFBtn variant="contained" size="small" onClick={()=>{handleDownload()}} $dimmed={false}>
                                <FileDownloadOutlinedIcon />
                            </PDFBtn>   
                        </div>
                    </div>                
                </div>}            
            </div>
        </>                      
    )
}